import { useHomePhrases } from '/@/components/home-tooltip';
import Title from '/@/v3/components/title';
import Drawing from '../drawing';
import styles from './styles.module.css';

const HomeMessage = ({ selectedFeature, country }) => {
    const PHRASES = useHomePhrases();

    return (
        <div className={styles.root}>
            <div className={styles.container}>
                <div className={styles.containerImg}>
                    <Drawing
                        size='sm'
                        type={country && country.name === 'Argentina' ? 'success-corn' : 'success-soy'}
                        style={{ width: 100, height: 100 }}
                    />
                </div>
                <div className={styles.containerText}>
                    <Title className={styles.text}>{PHRASES[selectedFeature] || PHRASES['default']}</Title>
                </div>
            </div>
        </div>
    );
};

export default HomeMessage;
